export const WALKTHROUGH_HISTORY_STATE_KEY =
  "therapistWalkthroughCue"

export const WALKTHROUGH_FORM_PROGRESS_EVENT =
  "plasticise:walkthrough-form-progress"

export const WALKTHROUGH_REFRESH_EVENT =
  "plasticise:walkthrough-refresh"

export const WALKTHROUGH_REVIEW_CUE_EVENT =
  "plasticise:walkthrough-review-cue"

export const WALKTHROUGH_PREVIEW_VIEWED_EVENT =
  "plasticise:walkthrough-preview-viewed"
